import { getRe_KYC_RequestResponse } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_digio_requestResponseThunk = createAsyncThunk(
  "reKyc_digio_requestResponseThunk",
  async ({ params, token }) => {
    try {
      const response = getRe_KYC_RequestResponse(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
